/**
 * Navigation Block
 *
 * Creates custom hamburger toggle for WordPress navigation block.
 * The hamburger has the .magnetic class which will be picked up
 * by the magnetic-buttons component.
 */

function initCustomHamburger() {
	const siteHeader = document.querySelector('.site-header');
	if (!siteHeader) return;

	// Don't create if already exists
	if (siteHeader.querySelector('.site-navigation__toggle')) return;

	// Create the toggle button with magnetic class
	const hamburger = document.createElement('button');
	hamburger.className = 'site-navigation__toggle btn magnetic';
	hamburger.setAttribute('type', 'button');
	hamburger.setAttribute('aria-label', 'Toggle menu');
	hamburger.setAttribute('aria-expanded', 'false');
	hamburger.dataset.strength = '25';
	hamburger.dataset.strengthText = '15';

	// Get the modal ID dynamically if possible
	const modalId = document.querySelector('.wp-block-navigation__responsive-container')?.id || 'modal-1';
	hamburger.setAttribute('aria-controls', modalId);

	// Build inner markup for magnetic button
	hamburger.innerHTML = `<div class="btn-click magnetic"><span class="btn-fill"></span><span class="btn-text"><span></span><span></span></span></div>`;

	// Prepend to header
	siteHeader.prepend(hamburger);

	// Toggle handler - triggers the hidden WP navigation buttons
	// Track our own state to prevent phantom clicks on Safari mobile
	let isToggling = false;
	let menuState = 'closed'; // Track state ourselves

	const toggleMenu = (e) => {
		// Stop all event propagation and default behavior
		e.stopPropagation();
		e.preventDefault();

		// Prevent any action during toggle animation
		if (isToggling) return;
		isToggling = true;

		// Use our tracked state instead of checking DOM classes
		// This prevents race conditions with DOM updates
		if (menuState === 'open') {
			menuState = 'closed';
			document.querySelector('.wp-block-navigation__responsive-container-close')?.click();
		} else {
			menuState = 'open';
			document.querySelector('.wp-block-navigation__responsive-container-open')?.click();
		}

		// Longer delay to ensure animation completes and prevent phantom clicks
		setTimeout(() => {
			isToggling = false;
		}, 800);
	};

	// Use touch events on mobile to prevent 300ms click delay and phantom clicks
	const isTouchDevice = ( 'ontouchstart' in window ) || ( navigator.maxTouchPoints > 0 );

	if (isTouchDevice) {
		// On touch devices, use touchend instead of click
		hamburger.addEventListener('touchend', toggleMenu, { passive: false });
	} else {
		// On desktop, use regular click
		hamburger.addEventListener('click', toggleMenu);
	}

	// Keep aria-expanded and internal state in sync with navigation state
	// This handles cases where the menu is closed by clicking outside or ESC key
	const observer = new MutationObserver(() => {
		const isOpen = document.documentElement.classList.contains('has-modal-open');
		hamburger.setAttribute('aria-expanded', isOpen);
		// Sync our internal state with the actual DOM state
		menuState = isOpen ? 'open' : 'closed';
	});

	observer.observe(document.documentElement, {
		attributes: true,
		attributeFilter: [ 'class' ],
	});
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initCustomHamburger);
} else {
	initCustomHamburger();
}

export { initCustomHamburger };
